import CartDetailedItemComponentDesktop from "./CartDetailedItemDesktop.Component";

export default CartDetailedItemComponentDesktop;
